import React, { useEffect, useState } from "react";
import {
  FiCalendar,
  FiCheckCircle,
  FiClock,
  FiUsers,
  FiUserCheck,
  FiUserX,
  FiBarChart2,
  // FiWatch,
  // FiGitPullRequest,
} from "react-icons/fi";
import DashboardLayout from "../../Layout/DashboardLayout";
import axios from "axios";
import { errorToast } from "../../Components/ToastMessage";

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalInterviews: 0,
    totalCompleted: 0,
    totalUpcoming: 0,
    totalCandidates: 0,
    totalCandidatesSelected: 0,
    totalCandidatesRejected: 0,
    totalInterviewsToday: 0,
    // averageInterviewDuration: "45 mins",
    // totalAIGeneratedAnswers: 20,
  });

  const cardData = [
    {
      title: "Total Interviews",
      value: stats.totalInterviews,
      icon: <FiCalendar />,
    },
    {
      title: "Completed Interviews",
      value: stats.totalCompleted,
      icon: <FiCheckCircle />,
    },
    {
      title: "Upcoming Interviews",
      value: stats.totalUpcoming,
      icon: <FiClock />,
    },
    {
      title: "Total Candidates",
      value: stats.totalCandidates,
      icon: <FiUsers />,
    },
    {
      title: "Candidates Selected",
      value: stats.totalCandidatesSelected,
      icon: <FiUserCheck />,
    },
    {
      title: "Candidates Rejected",
      value: stats.totalCandidatesRejected,
      icon: <FiUserX />,
    },
    {
      title: "Interviews Today",
      value: stats.totalInterviewsToday,
      icon: <FiBarChart2 />,
    },
    // {
    //   title: "Avg Interview Duration",
    //   value: stats.averageInterviewDuration,
    //   icon: <FiWatch />,
    // },
    // {
    //   title: "AI Generated Answers",
    //   value: stats.totalAIGeneratedAnswers,
    //   icon: <FiGitPullRequest />,
    // },
  ];

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get("/dashboard");
        if (response.data) {
          setStats(response.data);
        }
      } catch (error) {
        errorToast(error.message);
      }
    })();
  }, []);

  return (
    <DashboardLayout>
      <div className="h-full overflow-y-auto p-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Dashboard</h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6">
          {cardData.map((card, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-6 border border-slate-500 rounded-xl shadow-md"
            >
              <div>
                <h2 className="text-xl font-semibold text-gray-700">
                  {card.title}
                </h2>
                <p className="text-3xl font-bold text-gray-900">{card.value}</p>
              </div>
              <div className="text-4xl text-gray-600">{card.icon}</div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;
